<template>
  <div
    class="ipt"
    style="display: flex">
    <div class="mes-wapper jm-fl">
      <span><i class="annotation">*</i>学生姓名:</span>
      <el-input
        size="small"
        v-model="input"
        placeholder="请输入内容"/>
    </div>
    <div class="mes-wapper jm-fl">
      <span><i class="annotation">*</i>意向国家:</span>
      <span>英国</span>
    </div>
    <div class="mes-wapper jm-fl">
      <span><i class="annotation">*</i>学历:</span>
      <el-select
        v-model="value"
        placeholder="请选择">
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"/>
      </el-select>
    </div>
    <div class="mes-wapper">
      <el-select
        v-model="value"
        placeholder="请选择">
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"/>
      </el-select>
    </div>
    <div class="mes-wapper jm-fl">
      <span><i class="annotation">*</i>学历备注:</span>
      <el-input
        size="small"
        v-model="input"
        placeholder="请输入内容"/>
    </div>
    <slot :name='childShow'/>
  </div>
</template>
<script>
export default {
  props: {
    childShow: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      input: '',
      value: '',
      options: [{
        value: '选项1',
        label: '黄金糕'
      }, {
        value: '选项2',
        label: '双皮奶'
      }, {
        value: '选项3',
        label: '蚵仔煎'
      }, {
        value: '选项4',
        label: '龙须面'
      }, {
        value: '选项5',
        label: '北京烤鸭'
      }],
    };
  },
  methods: {
  },
  components: {
  },
};
</script>
